import React from "react";
import { PageNewState, DesignInfoInputDialogInitialState } from ".";

export const DesignInfoInputDialogContext = React.createContext({
  pageState: DesignInfoInputDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
